/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_Announcement_DismissInputs */

const en_google_drive_announcement_dismiss = /** @type {(inputs: Google_Drive_Announcement_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss the Google Drive announcement`)
};

const es_google_drive_announcement_dismiss = /** @type {(inputs: Google_Drive_Announcement_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar el anuncio de Google Drive`)
};

/**
* | output |
* | --- |
* | "Dismiss the Google Drive announcement" |
*
* @param {Google_Drive_Announcement_DismissInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_announcement_dismiss = /** @type {((inputs?: Google_Drive_Announcement_DismissInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_Announcement_DismissInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_announcement_dismiss(inputs)
	return en_google_drive_announcement_dismiss(inputs)
});